import React, { memo } from 'react';
import { useStyles } from './styles';

function QuoteIcon() {
  const styles = useStyles();

  return (
    <div className={styles.quoteIcon}>
      <svg viewBox="0 0 40 40" fill="currentColor">
        <path d="M16.156,10.448H8.922a1.808,1.808,0,0,0-1.809,1.808v7.613a1.806,1.806,0,0,0,1.809,1.807h6.844v1.448h0a4.232,4.232,0,0,1-4.227,4.228v2.2a6.435,6.435,0,0,0,6.428-6.428V12.256A1.808,1.808,0,0,0,16.156,10.448Z" />
        <path d="M31.078,10.448H23.844a1.808,1.808,0,0,0-1.809,1.808v7.613a1.806,1.806,0,0,0,1.809,1.807h6.844v1.448h0a4.232,4.232,0,0,1-4.227,4.228v2.2a6.435,6.435,0,0,0,6.428-6.428V12.256A1.808,1.808,0,0,0,31.078,10.448Z" />
      </svg>
    </div>
  );
}

export default memo(QuoteIcon);
